import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { organizeName, taxId },
} = checkout;

const validation = Yup.object().shape({
  [organizeName.name]: Yup.string().required(organizeName.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
});

export default validation;
